import { EPP_BODY } from "@/apollo/queries/epp";
import gql from "graphql-tag";

export const CHANGE_ESTADO_SOLICITUD_EPP = gql`
  mutation ChangeEstatusSolicitud(
    $id_estado_actual: Int!
    $id_nuevo_estado: Int!
    $id_solicitud: Int!
    $id_usuario: Int!
  ) {
    ChangeEstatusSolicitud(
      id_estado_actual: $id_estado_actual
      id_nuevo_estado: $id_nuevo_estado
      id_solicitud: $id_solicitud
      id_usuario: $id_usuario
    ) {
      id_solicitud
      id_usuario_fk
      id_formulario_fk
      estado_solicitud {
        id_estado
        nombre
      }
      ceco
      ot
      error
      fecha_creacion
      respuestas {
        cantidad_solicitada
        input
        campo {
          id_campo
          nombre
          header
        }
        opcion {
          id_opcion
          nombre
          descripcion
        }
        producto {
          id_producto
          nombre
          descripcion
          precio
          sku
          barcode
          ceco
          color
          genero
          categoria {
            nombre
            id_categoria
            categoria {
              id_categoria
              nombre
            }
          }
          talla {
            id_talla
            nombre
          }
        }
      }
      usuarios {
        id_usuario
        primer_nombre
        apellido_paterno
        empresa_cargos {
          id_cargo
          nombre_cargo
        }
      }
      colaborador {
        id_usuario
        primer_nombre
        apellido_paterno
        empresa_cargos {
          id_cargo
          nombre_cargo
        }
      }
      codigo_solicitud
    }
  }
`;

export const CHANGE_STATE_REQ_EPP = gql`
  mutation ChangeEstatusSolicitudUpdated(
    $idEstadoActual: Int!
    $idNuevoEstado: Int!
    $idSolicitud: Int!
    $idSolicitante: Int!
    $productosDetalle: [ProductosEntregar]!
  ) {
    ChangeEstatusSolicitudUpdated(
      id_estado_actual: $idEstadoActual
      id_nuevo_estado: $idNuevoEstado
      id_solicitud: $idSolicitud
      id_solicitante: $idSolicitante
      productos_detalle: $productosDetalle
    ) {
        id_solicitud
        id_usuario_fk
        id_formulario_fk
        estado_solicitud {
          id_estado
          nombre
        }
        ceco
        ot
        error
        fecha_creacion
        respuestas {
          cantidad_solicitada
          cantidad_modificada
          cantidad_entregada
          fecha_usoexp
          input
          campo {
            id_campo
            nombre
            header
          }
          opcion {
            id_opcion
            nombre
            descripcion
          }
          producto {
            id_producto
            nombre
            descripcion
            precio
            sku
            barcode
            ceco
            color
            genero
            codigo_producto
            categoria {
              nombre
              id_categoria
              categoria {
                id_categoria
                nombre
              }
            }
            talla {
              id_talla
              nombre
            }
          }
          lotes {
            id
            cantidad_entregar
            id_lote_fk
            id_respuesta_fk
            lote {
              id
              lote
              stock_real
              stock_entregado
            }
          }
        }
        usuarios {
          id_usuario
          primer_nombre
          apellido_paterno
          empresa_cargos {
            id_cargo
            nombre_cargo
          }
        }
        colaborador {
          id_usuario
          primer_nombre
          apellido_paterno
          empresa_cargos {
            id_cargo
            nombre_cargo
          }
        }
        codigo_solicitud
      firma {
        document_url
      }
      fecha_modificacion
    }
  }
`;

export const CHANGE_ESTADO_EPP = gql`
mutation ChangeEstatusProducto(
  $id_estado: Int!
  $codigo_producto: Int!
) {
  ChangeEstatusProducto(
    id_estado: $id_estado
    codigo_producto: $codigo_producto
  ) ${EPP_BODY}
}`;

/**
 * TallasEPP {
 *    sku:   String
 *    stock: Int
 *    talla: String
 * }
 *
 * imagen_b64: base64 sin el prefijo "data:" y formato_b64 su MIME
 * ("image/png"). Al editar, si la imagen no cambió, imagen_b64 lleva la URL
 * actual y el backend la conserva.
 *
 * periodicidad: horas entre solicitudes de la misma EPP, o null si no tiene.
 * Va siempre, también al editar: si no llega, el backend la deja en null.
 */
export const CREATE_EPP = gql`
mutation CreateEPPUpdated(
    $id_formulario: Int!,
    $nombre_epp: String!,
    $id_categoria: Int!,
    $limite: Int!,
    $precio: Float!,
    $descripcion: String,
    $imagen_b64: String,
    $formato_b64: String,
    $periodicidad: Int,
    $inventario: [TallasEPPUpdated]
) {
  CreateEPPUpdated(
    id_formulario: $id_formulario,
    nombre_epp: $nombre_epp,
    id_categoria: $id_categoria,
    limite: $limite,
    precio: $precio,
    descripcion: $descripcion,
    imagen_b64: $imagen_b64,
    formato_b64: $formato_b64,
    periodicidad: $periodicidad,
    inventario: $inventario
  ) ${EPP_BODY}
}`;

export const UPDATE_EPP = gql`
mutation UpdateEPPUpdated(
  $codigo_producto: Int!,
  $id_formulario: Int!,
  $nombre_epp: String!,
  $id_categoria: Int!,
  $limite: Int!,
  $precio: Float!,
  $descripcion: String,
  $imagen_b64: String,
  $formato_b64: String,
  $periodicidad: Int,
  $inventario: [TallasEPPUpdated]
) {
  UpdateEPPUpdated(
    codigo_producto: $codigo_producto,
    id_formulario: $id_formulario,
    nombre_epp: $nombre_epp,
    id_categoria: $id_categoria,
    limite: $limite,
    precio: $precio,
    descripcion: $descripcion,
    imagen_b64: $imagen_b64,
    formato_b64: $formato_b64,
    periodicidad: $periodicidad,
    inventario: $inventario
  ) ${EPP_BODY}
}`;

export const CREATE_BODEGA = gql`
  mutation CreateBodega($nombre: String!) {
    CreateBodega(nombre: $nombre) {
      id_bodega
      nombre
    }
  }
`;
export const UPDATE_BODEGA = gql`
  mutation UpdateBodega($id_bodega: Int!, $nombre: String!) {
    UpdateBodega(id_bodega: $id_bodega, nombre: $nombre) {
      id_bodega
      nombre
    }
  }
`;

// CREATE_BODEGA y UPDATE_BODEGA con su segmentación: una entrada por sociedad,
// cada una con sus propias sucursales. Solo se usan con
// BODEGAS_CON_SUCURSALES_Y_SOCIEDADES (store/modules/epp/Bodega.js).
//
// `sociedades` reemplaza a las listas planas id_sucursales / id_sociedades, que
// el backend sigue aceptando pero resuelve haciendo el producto cartesiano:
// asocia cada sucursal a cada sociedad, que casi nunca es lo que se quiso decir.
//
// Una sociedad con `id_sucursales` vacío significa la sociedad completa, no
// "sin sucursales". Se manda siempre la lista entera: lo que no viene, el
// backend lo da de baja.
//
// Necesita el backend 65479501 o posterior (ahí aparece
// BodegaSociedadSucursalesInput).
export const CREATE_BODEGA_CON_SEGMENTACION = gql`
  mutation CreateBodega($nombre: String!, $sociedades: [BodegaSociedadSucursalesInput]) {
    CreateBodega(nombre: $nombre, sociedades: $sociedades) {
      id_bodega
      nombre
    }
  }
`;
export const UPDATE_BODEGA_CON_SEGMENTACION = gql`
  mutation UpdateBodega(
    $id_bodega: Int!
    $nombre: String!
    $sociedades: [BodegaSociedadSucursalesInput]
  ) {
    UpdateBodega(id_bodega: $id_bodega, nombre: $nombre, sociedades: $sociedades) {
      id_bodega
      nombre
    }
  }
`;
export const DELETE_BODEGA = gql`
  mutation DeleteBodega($id_bodega: Int!) {
    DeleteBodega(id_bodega: $id_bodega) {
      id_bodega
      nombre
    }
  }
`;

export const CREATE_OR_UPDATE_JEFE_USUARIO = gql`
mutation CreateOrUpdateJefeUsuario($idUsuario: Int!, $usuarios: [Int]!) {
  CreateOrUpdateJefeUsuario(id_usuario: $idUsuario, usuarios: $usuarios) {
    id_usuario
    colaboradores {
      id_relacion
    }
  }
}
`;

export const DELETE_JEFE_USUARIO = gql`
  mutation DeleteJefeUsuario($id_usuario: Int!) {
    DeleteJefeUsuario(id_usuario: $id_usuario) {
      id_usuario
    }
  }
`;


//CreateOrUpdateSolicitudesAutomaticas

/*
[ObjectPeriodoValidacionesEPP]!
  Input Fields
    ejecuciones: [EjecucionesEPP]
    id_periodo:Int
    id_periodo_empresa:Int
    productos: [Int]
    validaciones: [ValidacionesEPP]
[EjecucionesEPP]
  Input Fields
    dias_ejecuciones:[Int]
    fechas_ejecuciones:[String]

[ValidacionesEPP]
  Input Fields
    c_area:[Int]
    c_cargo:[Int]
    c_ingreso:[RangosTiemposEPP]
    c_nacimiento:[RangosTiemposEPP]
    c_sindicatos:[Int]
    c_sucursal:[Int]
    c_turno:[Int]
    id_validacion:Int
[RangosTiemposEPP]
  Input Fields
    desde:Int
    hasta:Int
*/
export const CREATE_OR_UPDATE_SOLICITUDES_AUTOMATICAS = gql`
mutation CreateOrUpdateSolicitudesAutomaticas($idFormulario: Int!, $periodos: [ObjectPeriodoValidacionesEPP]!) {
  CreateOrUpdateSolicitudesAutomaticas(id_formulario: $idFormulario, periodos: $periodos) {
    id_periodo_empresa
    id_formulario_fk
    formulario {
      id_formulario
      nombre
      descripcion
      tipo_formulario {
        id_tipo
        nombre
        descripcion
        url_imagen
      }
      fecha_inicio
      fecha_fin
    }
    periodo {
      id_tipo
      nombre
      cantidad_dias
    }
    validacion {
      id_condicion
      c_cargo
      c_area
      c_sucursal
      c_turno
      c_sindicato
      c_nacimiento_desde
      c_nacimiento_hasta
      c_ingreso_desde
      c_ingreso_hasta
      tipo {
        id_tipo
        nombre
        parametro
      }
    }
    productos {
      codigo_producto
      producto {
        id_producto
        nombre
        descripcion
        precio
        sku
        barcode
        ceco
        color
        genero
        codigo_producto
        id_estado_fk
      }
    }
    ejecucion {
      id_ejecucion
      dia_ejecucion
      fecha_ejecucion
    }
  }
}`;

// Sin is_supervisor: el backend lo deja en false
export const CREATE_ENCARGADO = gql`
  mutation CreateEncargado($id_usuario: Int!, $id_formulario: Int!) {
    CreateEncargado(id_usuario: $id_usuario, id_formulario: $id_formulario) {
      id_encargado
      id_usuario_fk
    }
  }
`;

// Desactiva el encargado (id_estado_fk inactivo), no lo borra
export const DELETE_ENCARGADO = gql`
  mutation DeleteEncargado($id_encargado: Int) {
    DeleteEncargado(id_encargado: $id_encargado) {
      id_encargado
      id_estado_fk
    }
  }
`;

// CREATE_ENCARGADO con rol y bodegas. Solo se usa con ENCARGADOS_CON_BODEGAS
// (store/modules/epp/Encargados.js). Crea o, si la persona ya fue encargada en el
// formulario, edita: reemplaza is_supervisor, id_privilegio_fk y las bodegas, así
// que al editar se envían siempre los tres. Si faltan is_supervisor o
// id_privilegio_fk, el backend los completa por su cuenta.
export const CREATE_ENCARGADO_CON_BODEGAS = gql`
  mutation CreateEncargado(
    $id_usuario: Int!
    $id_formulario: Int!
    $is_supervisor: Boolean
    $id_privilegio_fk: Int
    $id_bodegas: [Int]
  ) {
    CreateEncargado(
      id_usuario: $id_usuario
      id_formulario: $id_formulario
      is_supervisor: $is_supervisor
      id_privilegio_fk: $id_privilegio_fk
      id_bodegas: $id_bodegas
    ) {
      id_encargado
      id_usuario_fk
    }
  }
`;

// Reemplaza todos los permisos de EPP de la empresa por los enviados. El backend
// no valida que sean excluyentes: se envía uno de solicitud y uno de automatizaciones
export const CREATE_OR_UPDATE_PERMISOS_SI = gql`
  mutation createOrUpdatePermisosSi($id_permiso: [Int]!) {
    createOrUpdatePermisosSi(id_permiso: $id_permiso) {
      id_permiso_empresa
      permiso {
        id_permiso
        solo_jefe
        colaborador
        automatizaciones
      }
    }
  }
`;
